import { render, staticRenderFns } from "./FilterShop.vue?vue&type=template&id=33b3e1ce&"
import script from "./FilterShop.vue?vue&type=script&lang=js&"
export * from "./FilterShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports